<template>
  <div>
     <v-container>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step step="1">{{$t("app.your_company") }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2">{{$t("app.client")}}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">{{$t("app.products")}}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4">{{$t("app.taxes")}}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="5">{{$t("app.invoice_info")}}</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <step-one></step-one>
        </v-stepper-content>

        <v-stepper-content step="2">
          <step-two></step-two>
        </v-stepper-content>

        <v-stepper-content step="3">
          <step-three></step-three>
        </v-stepper-content>
        <v-stepper-content step="4">
          <step-four></step-four>
        </v-stepper-content>
        <v-stepper-content step="5">
          <step-five></step-five>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-snackbar v-model="snack.show" :timeout="3000" :color="snack.color"  >
      {{ snack.text }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
     </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import StepOne from "../../components/invoiceStepper/StepOne";
import StepTwo from "../../components/invoiceStepper/StepTwo";
import StepThree from "../../components/invoiceStepper/StepThree";
import StepFour from "../../components/invoiceStepper/StepFour";
import StepFive from "../../components/invoiceStepper/StepFive";

export default {
  name: "Stepper",
  components: { StepOne, StepTwo, StepThree, StepFour, StepFive },
  computed: {
    ...mapState(["invoice", "e1","snack"])
  },
  data: () => ({
    dialog: false,
    edit: false
  }),
  methods: {
    ...mapActions(["updateInvoice"]),
    nextStepper() {
      this.$refs.form.validate();
      this.$validator.validate().then(valid => {
        if (!valid) {
          // do stuff if not valid.
        } else {
          this.e1++;
        }
      });
    },
    
  },
  mounted() {}
};
</script>

<style scoped>
</style>